<template>
  <div class="container-fluid user-wrapper mt-4">
    <!--<div class="user-infos">
      <h3 class="user-infos-name">
        {{ `${user.firstname} ${user.lastname}` }}
      </h3>
      <div class="user-infos-button">
        <base-button
          v-if="$currentUserCan($permissions.PERM_EDIT_USERS)"
          icon
          size="sm"
          @click="editProfile()"
        >
          <span class="btn-inner--icon">
            <i class="fal fa-edit"></i>
          </span>
        </base-button>
      </div>
    </div>-->
    <div class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="false">
          <span slot="title">
            <i class="fa-regular fa-list"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <user-view-global :user="user" @onUpdateUser="editProfile" />
        </tab-pane>

        <tab-pane title="global" id="2" :active="true" class="locations">
          <span slot="title">
            <i class="fa-regular fa-map"></i>
            {{ $t("COMMON.MY_LOCATIONS") }}
          </span>
          <div class="">
            <user-location-list-table
              :locations="user?.allowedLocations"
              @onUserUpdated="get"
            />
          </div>
        </tab-pane>

        <tab-pane title="security" id="3" :active="false">
          <span slot="title">
            <i class="fa-light fa-screwdriver-wrench"></i>
            {{ $t("USERS.SECURITY") }}
          </span>
          <user-security :user="user" @onUserUpdated="get" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import UserViewGlobal from "@/views/Pages/AdminModule/UserManagement/partials/UserViewGlobal.vue";
import UserSecurity from "@/views/Pages/AdminModule/UserManagement/partials/UserSecurity.vue";
import defaultUser from "@/views/Pages/AdminModule/UserManagement/defaultUser";
import UserLocationListTable from "./partials/UserLocationListTable";
import requestErrorMixin from "@/mixins/request-error-mixin";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    UserViewGlobal,
    UserSecurity,
    UserLocationListTable,
  },

  mixins: [requestErrorMixin, hasTabs],

  data() {
    return {
      user: cloneDeep(defaultUser),
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("profile/me");
        this.user = this.$store.getters["profile/me"];
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editProfile() {
      this.$router.push({
        name: "Edit Profile",
      });
    },
  },
};
</script>
